<template>
  <div>
    <v-list-item link>
      <v-list-item-icon>
        <v-btn icon small @click.stop="show = !show">
          <v-icon :style="!show ? 'transform: rotate(-90deg)' : null">keyboard_arrow_down</v-icon>
        </v-btn>
      </v-list-item-icon>
      <v-list-item-content>{{ category.name }}</v-list-item-content>
    </v-list-item>
    <v-expand-transition>
      <v-list v-show="show" dense class="pt-0 pl-3">
        <research-list-item
          v-for="research in category.research"
          :key="research.id"
          :research="research"
        ></research-list-item>
      </v-list>
    </v-expand-transition>
  </div>
</template>
 
<script>
import ResearchListItem from './ResearchListItem';

export default {
  props: ['category'],
  components: { ResearchListItem },
  data() {
    return {
      show: true
    };
  },
  computed: {
    catResearch() {}
  }
};
</script>

<style></style>
